module.exports = __webpack_public_path__ + "img/bayad_center.c90c2be1.png";